import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-6">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutData.content}
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 bg-primary-50 rounded-lg">
              <i className="ri-shield-check-line text-primary-500"></i>
              <span className="text-xs font-medium text-primary-700">信息严格审核</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-accent-50 rounded-lg">
              <i className="ri-speed-line text-accent-500"></i>
              <span className="text-xs font-medium text-accent-700">极速更新响应</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary-100 rounded-lg">
              <i className="ri-group-line text-secondary-600"></i>
              <span className="text-xs font-medium text-secondary-700">百万用户信赖</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}